import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EmailTemplateModel } from 'common/models/page-models/Email-Template/email-template-data-model';
import { EmailTemplateListingModel } from 'common/models/page-models/Email-Template/email-template-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { EmailTemplateGridWidgetService } from 'common/widget/email-template/email-template-grid-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class EmailTemplateGridResolver extends GridResolver<EmailTemplateModel, EmailTemplateListingModel> {
    constructor(
        protected fs: EmailTemplateGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}